<div
    (click)="showConsultancyCard()"
    (mouseenter)="hoverIn.emit();"
    (mouseleave)="hoverOut.emit();"
    class="position-relative card-container w-100 primary-text">
    <div [ngClass]="showDetailCard || showHoverCard ? 'd-none' : 'd-flex'"
         class="position-absolute text-card flex-column justify-content-center align-items-center {{cardObj.backgroundColor}}">
        <span class="card-title secondary-text">{{cardObj.index}}</span>
        <span class="card-subtitle">{{cardObj.name}}</span>
    </div>

    <div [ngClass]="showDetailCard || showHoverCard ? 'd-flex' : 'd-none'" class="position-absolute card detail-card">
        <div class="card-body d-flex flex-column">
            <div class="card-title secondary-text">{{cardObj.index}}</div>
            <div class="card-subtitle">{{cardObj.name}}</div>
            <ul class="card-text p-0 flex-grow-1">
                @for(item of cardObj.descriptionList; track $index){
                <li>{{item}}</li>
                }
            </ul>
            <ngb-progressbar [value]="progressValue" height="5px"></ngb-progressbar>
        </div>
    </div>
</div>
